<template>
  <v-container class="pa-0">
    <div id="plan" class="overflow-y-auto" v-if="!emptyDataFlag">
      <v-row class="title-wrap" v-scroll:#plan="handleScroll">
        <v-col cols="12" class="icon-title"
          ><icon-work-day :width="22" :height="22" />연차휴가계획을
          작성해주세요.</v-col
        >
        <v-col cols="12" class="pt-0 px-6 title-desc">
          <!-- 가능일수  -->
          <v-chip label class="chip-desc" color="#E8F9ED">
            <span>
              연차 사용 기간
              {{ planPeriod }}
            </span>
          </v-chip>
          <!-- 잔여연차 -->
          <annual-plan-status
            :fixed="false"
            :planCnt="planCnt"
            :restCnt="restCnt"
          />
          <!-- 스크롤시 고정된 잔여연차 영역 노출 -->
          <annual-plan-status
            v-if="scrolled"
            :fixed="true"
            :planCnt="planCnt"
            :restCnt="restCnt"
          />
        </v-col>
      </v-row>
      <!-- 반복 단위 시작 -->
      <annual-plan-write-item
        v-for="(plan, index) in planList"
        :key="index"
        :index="index"
        :planObj="plan"
        @deletePlan="removePlan"
        @showDate="showDate"
        @showList="showList"
      />
      <!-- 반복 단위 끝 -->

      <!-- 추가하기 버튼 -->
      <v-row align="center" justify="space-around" class="ma-0 mt-4 pb-8">
        <v-btn elevation="0" class="btn-more" height="38" @click="addPlan">
          <span class="black--text">
            <v-icon size="18" class="mr-1">mdi-plus</v-icon>
            추가하기
          </span>
        </v-btn>
      </v-row>
    </div>

    <!-- 하단 버튼 -->
    <v-bottom-navigation
      v-if="!emptyDataFlag"
      fixed
      scroll-target="#scroll-threshold-example"
      scroll-threshold="500"
      height="96"
    >
      <v-row class="ma-0 py-5 px-6 btn-fixed-wrapper">
        <v-col cols="6" class="py-0 pl-0 pr-2">
          <v-btn
            block
            elevation="0"
            class="btn-fixed btn-grey"
            @click="savePlan()"
          >
            <span class="white--text">저장</span>
          </v-btn>
        </v-col>
        <v-col cols="6" class="py-0 pl-2 pr-0">
          <v-btn
            block
            elevation="0"
            class="btn-fixed btn-blue"
            @click="savePlanFinish"
          >
            <span class="white--text">계획제출</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-bottom-navigation>

    <!-- 날짜선택 모달 -->
    <select-annual-plan-date-dialog @selectDate="selectDate" />

    <!-- 근태종류 선택 목록-->
<!--    <bottom-select-->
<!--      :flag="bottomSelect"-->
<!--      :list="GET_GNT_CD_LIST"-->
<!--      :title="'근태종류'"-->
<!--      @selectItem="selectGntCd"-->
<!--    />-->
    <v-bottom-sheet v-if="bottomSelect" v-model="bottomSelect">
      <bottom-sheet :title="'근태종류'" :default="selected" :items="GET_GNT_CD_LIST" @selectItem="selectGntCd"></bottom-sheet>
    </v-bottom-sheet>

    <!-- empty Data component -->
    <no-applicable
      v-if="emptyDataFlag"
      :text="emptyDataText"
      :toMainBtn="true"
    />
  </v-container>
</template>
<script>
import IconWorkDay from '@/assets/customIcon/IconWorkDay.vue';
import AnnualPlanWriteItem from '@/components/application/annualPlan/AnnualPlanWriteItem.vue';
import AnnualPlanStatus from '@/components/application/annualPlan/AnnualPlanStatus.vue';

import BottomSelect from '@/components/application/form/BottomSelect.vue';
import SelectAnnualPlanDateDialog from '@/components/application/dialog/SelectAnnualPlanDateDialog.vue';
import NoApplicable from '@/components/common/NoApplicable.vue';

import { getCodeNm } from '@/utils/common/codeUtil';
import routerNames from '@/const/routerConstants';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
dayjs.extend(isBetween);

import {
  getAnnualPlanYearList,
  getAnnualPlanList,
  getAnnualPlanYearInfo,
  postAnnualPlan,
  deleteAnnualPlan,
  postAnnualPlanFinish,
} from '@/api/annualPlan';
import { mapGetters } from 'vuex';
import BottomSheet from "@/components/application/form/BottomSheet.vue";

export default {
  data() {
    return {
      emptyDataFlag: false,
      emptyDataText: '',
      planList: [
        {
          date: '',
          codeObj: { code: '', codeNm: '' },
          holDay: 0, // 전체일수
          closeDay: 0, // 적용일수
          saved: false,
        },
      ],
      scrollPostion: 0,
      scrolled: false,
      bottomSelect: false,
      activeIndex: -1,
      selected : '',

      yearData: {},
      restCnt: 0,
      planCnt: 0,

      updateFlag: false, // 수정 여부
    };
  },
  computed: {
    ...mapGetters(['GET_USER_DATA']),
    ...mapGetters('CODE', ['GET_GNT_CD_LIST']),
    ...mapGetters('ELA', ['GET_CLOSE_DAY', 'GET_HOL_DAY']),

    // 연차사용기간
    planPeriod() {
      return ` ${dayjs(this.yearData.useSYmd).format('YYYY-MM-DD')} ~ ${dayjs(
        this.yearData.useEYmd,
      ).format('YYYY-MM-DD')}`;
    },
  },
  methods: {
    /* 계획 추가 */
    addPlan() {
      const restPlanCnt = this.restCnt - this.planCnt;
      if (restPlanCnt <= 0) {
        alert('잔여연차가 없습니다.');
        return false;
      }

      this.planList.push({
        date: '',
        codeObj: { code: '', codeNm: '' },
        holDay: 0, // 전체일수
        closeDay: 0, // 적용일수
        saved: false,
      });

      this.updateFlag = true;
    },

    /* 계획 삭제 */
    async removePlan(removeObj, index) {
      if (!removeObj.saved) {
        // 저장 전 데이터 삭제
        this.planList.splice(index, 1);
        this.setPlanCnt();
        return false;
      } else {
        // 저장된 데이터 삭제
        if (!confirm('삭제하시겠습니까?')) return false;
        const params = {
          searchSabun: this.GET_USER_DATA.ssnSabun,
          searchGubun: this.yearData.gubun,
          searchUseSYmd: this.yearData.useSYmd,
          sYmd: dayjs(removeObj.date).format('YYYYMMDD'),
          gntCd: removeObj.codeObj.code,
        };

        try {
          const response = await deleteAnnualPlan(params);
          if (response.data.data > 0) {
            alert('삭제되었습니다.');
          } else {
            alert('잠시 후 다시 시도해주세요.');
          }
          this.fetchAnnualPlanList();
        } catch (error) {
          console.log(error);
        }
      }

      this.setPlanCnt();
    },

    /* 근태코드 목록 노출 */
    showList(index) {
      this.activeIndex = index;
      this.bottomSelect = !this.bottomSelect;
    },

    /* 근태코드 선택 */
    selectGntCd(item) {
      this.$store.commit('ELA/SET_GNT_CD', item);
      this.bottomSelect = !this.bottomSelect;
      const codeObj = {
        code: item.code,
        codeNm: item.codeNm,
      };
      this.selected = item.code;
      this.planList[this.activeIndex]['codeObj'] = codeObj;
      this.planList[this.activeIndex]['closeDay'] = 0;
      this.planList[this.activeIndex]['date'] = '';

      this.updateFlag = true;
    },

    /* 근태코드 조회 */
    async fetchGntCd() {
      await this.$store.dispatch('CODE/FETCH_GNT_CD', {
        cmd: 'gntCdApp',
        searchGntGubunCd: 1,
      });
    },

    /* 날짜 선택 모달 노출 */
    showDate(index) {
      this.activeIndex = index;
      if (this.planList[this.activeIndex].codeObj.code === '') {
        alert('근태종류를 선택해주세요.');
        return false;
      }

      this.$store.commit('DIALOG/TOGGLE_MODAL', 'select_annual_plan_date');
    },

    /* 날짜 선택시 */
    selectDate(date) {
      const isBetweenPlanPeriod = dayjs(date.replaceAll('-', '')).isBetween(
        this.yearData.useSYmd,
        this.yearData.useEYmd,
      );
      if (!isBetweenPlanPeriod) {
        alert(`연차는 ${this.planPeriod} 기간 안에서 사용해주세요.`);
        return false;
      }

      this.planList[this.activeIndex]['date'] = date;
      this.planList[this.activeIndex]['closeDay'] = Number(this.GET_CLOSE_DAY);
      this.planList[this.activeIndex]['holDay'] = Number(this.GET_HOL_DAY);
      this.setPlanCnt();
      this.updateFlag = true;
    },

    /* 계획일수 갱신 */
    setPlanCnt() {
      this.planCnt = 0;
      this.planList.forEach(element => {
        this.planCnt += Number(element.closeDay);
      });

      this.$store.commit('SPINNER/OFF_COMMON_SPINNER');
    },

    /* 년도 목록 조회 */
    async fetchAnnualPlanYearList() {
      try {
        const response = await getAnnualPlanYearList({
          searchSabun: this.GET_USER_DATA.ssnSabun,
        });
        const yearList = response.data.data;
        const curYear = dayjs().year().toString();

        // 현재년도 데이터
        const curYearDataList = yearList.filter(obj => obj.year === curYear);

        if (curYearDataList.length > 1) {
          // 현재 년도 2개 이상일때
          this.emptyDataText = '웹에서 연차사용계획을 작성 해주세요.';
          this.emptyDataFlag = true;
          this.$store.commit('SPINNER/OFF_COMMON_SPINNER');
        } else if (curYearDataList.length === 1) {
          this.yearData = curYearDataList[0];

          // 계획 제출이 완료 됐을때
          if (this.yearData.closeYn === 'Y') {
            alert('계획제출이 완료되었습니다.');
            this.$store.commit('SPINNER/OFF_COMMON_SPINNER');
            this.$router.push(routerNames.AnnualPlan);
            return false;
          }

          // 촉진기간 확인
          const curDate = dayjs();
          const firstPeriod = curDate.isBetween(
            this.yearData.plan1stSYmd,
            this.yearData.plan1stEYmd,
          ); // 1차촉진기간
          const secondPeriod = curDate.isBetween(
            this.yearData.plan2ndSYmd,
            this.yearData.plan2ndEYmd,
          ); // 2차촉진기간

          if (firstPeriod || secondPeriod) {
            // 촉진기간일때
            this.fetchAnnualPlanYearInfo();
            this.fetchAnnualPlanList();
          } else {
            // 촉진기간 아닐때
            this.emptyDataText = '촉진 기간이 아닙니다.';
            this.emptyDataFlag = true;
          }
        } else {
          //
        }
        this.$store.commit('SPINNER/OFF_COMMON_SPINNER');
      } catch (error) {
        console.log(error);
        this.$store.commit('SPINNER/OFF_COMMON_SPINNER');
      }
    },

    /* 연차사용계획작성 목록 조회 */
    async fetchAnnualPlanList() {
      try {
        const { data } = await getAnnualPlanList({
          searchSabun: this.GET_USER_DATA.ssnSabun,
          searchUseSYmd: this.yearData.useSYmd,
          searchUseEYmd: this.yearData.useEYmd,
          searchGubun: this.yearData.gubun,
          editYn: this.yearData.editYn,
        });

        const planList = data.data.filter(obj => obj.line === 'B');
        if (planList.length > 0) {
          if (planList[0].note === null) {
            // 웹에서 저장된 데이터 있을때
            this.emptyDataText =
              '웹에서 작성중인 연차사용계획이 있습니다.<br/> 웹에서 계속 진행해주세요.';
            this.emptyDataFlag = true;
          } else if (planList[0].note === 'MOBILE') {
            // 앱에서 저장된 데이터 있을때
            this.planList = [];
            planList.forEach(element => {
              this.planList.push({
                date: dayjs(element.sYmd).format('YYYY-MM-DD'),
                codeObj: {
                  code: element.gntCd,
                  codeNm: getCodeNm(this.GET_GNT_CD_LIST, element.gntCd),
                },
                holDay: element.holDay,
                closeDay: element.closeDay,
                saved: true,
              });
            });
          }
        } else {
          // 앱에서 저장된 데이터 없을때
          this.planList = [
            {
              date: '',
              codeObj: { code: '', codeNm: '' },
              holDay: 0, // 전체일수
              closeDay: 0, // 적용일수
              saved: false,
            },
          ];
        }
        this.setPlanCnt();
      } catch (error) {
        console.log(error);
      }
    },

    /* 연도별 잔여연차 조회 */
    async fetchAnnualPlanYearInfo() {
      try {
        const { data } = await getAnnualPlanYearInfo({
          searchSabun: this.GET_USER_DATA.ssnSabun,
          searchUseSYmd: this.yearData.useSYmd,
          searchUseEYmd: this.yearData.useEYmd,
          searchGubun: this.yearData.gubun,
          editYn: this.yearData.editYn,
        });

        this.restCnt = data.data.restCnt;
      } catch (error) {
        console.log(error);
      }
    },

    /* 계획 저장 */
    async savePlan() {
      if (!this.updateFlag) {
        alert('변경된 내용이 없습니다.');
        return false;
      }

      // 날짜 중복검사
      const dateArr = this.planList.map(element => element.date);
      const setCollection = new Set(dateArr);
      const isDuplicate = setCollection.size < dateArr.length;
      if (isDuplicate) {
        alert('중복된 일자가 존재 합니다.');
        return false;
      }

      const mergeRows = [];
      let errorCnt = 0;

      this.planList.forEach(element => {
        if (errorCnt > 0) return false;

        if (element.closeDay === 0) {
          // 적용일수 확인
          alert('적용일수가 0일 입니다. 다른 날짜를 입력 해주세요.');
          errorCnt++;
        } else {
          mergeRows.push({
            searchSabun: this.GET_USER_DATA.ssnSabun,
            searchGubun: this.yearData.gubun,
            searchUseSYmd: this.yearData.useSYmd,
            gntCd: element.codeObj.code,
            sYmd: dayjs(element.date).format('YYYYMMDD'),
            eYmd: dayjs(element.date).format('YYYYMMDD'),
            holDay: element.holDay,
            closeDay: element.closeDay,
          });
        }
      });

      if (errorCnt > 0) return false;
      if (!confirm('계획을 저장하시겠습니까?')) return false;

      const params = {
        searchSabun: this.GET_USER_DATA.ssnSabun,
        searchGubun: this.yearData.gubun,
        searchUseSYmd: this.yearData.useSYmd,
        searchUseEYmd: this.yearData.useEYmd,
        note: 'MOBILE',
        mergeRows,
      };

      try {
        const response = await postAnnualPlan(params);
        alert(response.data.message);
        this.updateFlag = false;
        this.fetchAnnualPlanList(); // 재조회
      } catch (error) {
        console.log(error);
      }
    },

    /* 계획 제출 */
    async savePlanFinish() {
      // 계획일수 충족 체크
      if (this.planCnt !== this.restCnt) {
        alert(
          `잔여일수(${this.restCnt}일)와 계획일수(${this.planCnt}일)가 동일해야 합니다.`,
        );
        return false;
      }

      // 저장안된 계획 체크
      const unsavedCnt = this.planList.filter(plan => !plan.saved).length;
      if (unsavedCnt > 0 || this.updateFlag) {
        alert(`저장되지 않은 데이터가 있습니다. 저장 먼저 해주세요.`);
        return false;
      }

      if (!confirm('계획을 제출하시겠습니까?')) return false;

      const params = {
        searchSabun: this.GET_USER_DATA.ssnSabun,
        searchGubun: this.yearData.gubun,
        searchUseSYmd: this.yearData.useSYmd,
      };

      try {
        const response = await postAnnualPlanFinish(params);
        if (response.data.data > 0) {
          alert('계획제출이 완료되었습니다.');
          this.$router.push(routerNames.AnnualPlan);
        } else {
          alert('잠시 후 다시 시도해주세요.');
        }
      } catch (error) {
        console.log(error);
      }
    },

    handleScroll(e) {
      this.scrollPostion = e.target.scrollTop;
      if (e.target.scrollTop > 120) {
        this.scrolled = true;
      } else {
        this.scrolled = false;
      }
    },
  },
  created() {
    this.$store.commit('SPINNER/ON_COMMON_SPINNER');
    this.fetchGntCd();
    this.fetchAnnualPlanYearList();
  },
  components: {
    BottomSheet,
    NoApplicable,
    IconWorkDay,
    AnnualPlanWriteItem,
    AnnualPlanStatus,
    BottomSelect,
    SelectAnnualPlanDateDialog,
  },
};
</script>
<style scoped>
/* annualPlan.scss 참고 */
</style>
